import addNotification from '../services/notificationService';
import { upvoteQuestion, downvoteQuestion } from '../services/questionService';
import { Question, Notification, NotificationType } from '../types';
import useUserContext from './useUserContext';
import useVoteStatus from './useVoteStatus';

const useVoteComponent = (question: Question) => {
  const { user } = useUserContext();
  const { count, voted } = useVoteStatus({ question });

  /**
   * Function to handle upvoting or downvoting a question.
   *
   * @param type - The type of vote, either 'upvote' or 'downvote'.
   */
  const handleVote = async (type: string) => {
    try {
      if (question._id) {
        if (type === 'upvote') {
          await upvoteQuestion(question._id, user.username);
        } else if (type === 'downvote') {
          await downvoteQuestion(question._id, user.username);
        }
        const notif: Notification = {
          message:
            type === 'upvote'
              ? `{sender} gave your question an upvote`
              : `{sender} gave your question a downvote`,
          sender: user,
          receiver: question.askedByUser,
          notificationType: type === 'upvote' ? NotificationType.Upvote : NotificationType.Downvote,
          notificationDateTime: new Date(),
          path: `/question/${question._id}`,
        };
        addNotification(notif);
      }
    } catch (error) {
      // Handle error
    }
  };

  return { voted, handleVote, count };
};

export default useVoteComponent;
